// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2_cssnano@5.1.15_postcss@8.4.47__postcss@8.4.47_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.v-toolbar .menu-spacer[data-v-7ba5bd90] {
  width: 60px;
  height: 56px;
  flex-shrink: 0;
}
/* #inspire  >>> .v-toolbar__content{padding-left: 0px !important;} */
.call-button[data-v-7ba5bd90] .v-btn .v-icon {
  color: #fff;
}
.custom-theme-wrapper .v-content__wrap > .container[data-v-7ba5bd90] {
  padding: 0px;
}
.application[data-v-7ba5bd90] .v-speed-dial {
  position: fixed;
  z-index: 11;
}
.sessionOutText[data-v-7ba5bd90] {
  font-size: 15px;
  line-height: 1.5;
}
.sessionOutText span[data-v-7ba5bd90] {
  color: #ff0000;
}
.top-menubar[data-v-7ba5bd90] {
  z-index: 11 !important;
}
.side-menubar[data-v-7ba5bd90] {
  margin-top: 64px !important;
  height: calc(100% - 64px) !important;
}
.v-navigation-drawer--is-mobile[data-v-7ba5bd90],
.v-navigation-drawer--temporary[data-v-7ba5bd90] {
  z-index: 10;
}
.overlay-images[data-v-7ba5bd90] {
  position: absolute;
  left: 0px;
  right: 0px;
  top: 0px;
  bottom: 0px;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 997;
}
.back-btn[data-v-7ba5bd90] .jobview-hide .v-btn {
  left: -79px;
}
.hide-dashboard[data-v-7ba5bd90] {
  visibility: hidden;
}
.show-dashboard[data-v-7ba5bd90] {
  visibility: visible;
}
.img-wrap[data-v-7ba5bd90] {
  width: 130px;
  margin: 0 auto;
}
.img-wrap img[data-v-7ba5bd90] {
  max-width: 100%;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
